import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

// Initialise context
export const AuthContext = createContext();

axios.defaults.withCredentials = true;

const ACCESS_TOKEN_STORAGE_KEY = 'accessToken';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check if user is logged in when the app loads
  useEffect(() => {
    const checkUserStatus = async () => {
      try {
        const storedToken = sessionStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
        if (storedToken) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
        }

        const { data } = await axios.get('https://api.alientrader.cards/user-status');
        setUser(data.user);
        setLoading(false);
      } catch (err) {
        sessionStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
        delete axios.defaults.headers.common['Authorization'];
        setUser(null);
        setLoading(false);
      }
    };
    checkUserStatus();
  }, []);

  const login = async (username, password) => {
    try {
      const { data } = await axios.post('https://api.alientrader.cards/auth/login', { user: username, pwd: password });
      console.log(data.user);
      setUser(data.user);

      if (data.accessToken) {
        sessionStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, data.accessToken);
        axios.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`;
      }

      return true;
    } catch (err) {
      return false;
    }
  };

  const logout = async () => {
    try {
      await axios.post('https://api.alientrader.cards/auth/logout');

      sessionStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
      delete axios.defaults.headers.common['Authorization'];
      setUser(null);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
